import React from 'react'
import cx from 'classnames'
import { map } from 'libraries/lodash'
import Grid from '@mui/material/Grid'
import url from 'libraries/front-end-core/core/url'
import { ACCOUNT } from 'constants/controllers'
import PageHeader from 'components/account/PageHeader'
import ContainedButton from 'components/search/ContainedButton'

const Navigation = ({ view, views, userIs }) => {
  const filteredViews = map(views, ({ label, visible, role }, itemView) => {
    const active = itemView === view
    const display = visible && (userIs(role) || !role)
    return ({ label, active, itemView, display })
  }).filter(({ display }) => display)

  const smColumns = filteredViews.length === 4 ? 6 : 4

  return (
    <div className='mt6-m mt6-t mt8'>
      <span className='dn-m'><PageHeader margin='mt2 mb7' title='My Account' /></span>
      <Grid container spacing={1}>
        {filteredViews.map(({ itemView, label, active }) => (
          <Grid item xs={12} sm={smColumns} md={12} key={itemView}>
            <NavigationItem {...{ label, active }} view={itemView} />
          </Grid>
        ))}
      </Grid>
    </div>
  )
}

export const NavigationItem = ({
  active,
  label,
  view
}) => (
  <div
    className={cx('f5 ds outline-0', {
      grey: !active,
      'dark-cyan': active
    })}
    data-event-category='Account'
    data-event-action='View'
    data-event-label={label}
  >
    <ContainedButton
      title={label}
      selected={active}
      iconName={getIconName(label)}
      href={!active ? url(ACCOUNT, { view }) : null}
      buttonCxNames={cx('ttc b f5', {
        'bg-white ba b--cadet-blue': !active,
        'account-nav-button': active
      })}
      hideIcon={false}
    />
  </div>
)

const getIconName = (title) => {
  switch (title.toLowerCase()) {
    case 'user details':
      return 'icon-account-outline'
    case 'search history':
      return 'icon-history'
    case 'my preferences':
      return 'icon-settings'
    default:
      return null
  }
}

export default Navigation
